import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import {Menu, MenuItem, ListItemIcon, ListItemText, withStyles} from '@material-ui/core'

const styles = {
    text: {
        padding: 0
    },

    link: {
        textDecoration: 'none',
        '&:focus': {
            outline: 'none'
        }
    },

    danger: {}
}

class MenuButton extends Component {
    state = {
        anchorEl: null
    }

    handleClick = ({currentTarget: anchorEl}) => this.setState({anchorEl})

    handleClose = item => () => {
        this.setState({anchorEl: null})
        if (item && item.onClick) item.onClick(this.props.subject)
    }

    asLink = (key, link, children) => (
        <Link key={key} to={link} className={this.props.classes.link}>
            {children}
        </Link>
    )

    render() {
        const {anchorEl} = this.state
        const {id, options, children, classes: styles} = this.props

        return (
            <div>
                <div
                    aria-owns={anchorEl ? `${id}-menu` : undefined}
                    aria-haspopup="true"
                    onClick={this.handleClick}
                >
                    {children}
                </div>
                <Menu
                    id={`${id}-menu`}
                    anchorEl={anchorEl}
                    anchorOrigin={{vertical: 'center', horizontal: 'left'}}
                    open={Boolean(anchorEl)}
                    onClose={this.handleClose()}
                    getContentAnchorEl={null}
                >
                    {options.map((item, index) => {
                        const children = (
                            <MenuItem key={index} onClick={this.handleClose(item)}>
                                <ListItemIcon>
                                    {item.icon}
                                </ListItemIcon>
                                <ListItemText classes={{root: styles.text}} inset>
                                    {item.label}
                                </ListItemText>
                            </MenuItem>
                        )
                        return item.linkTo ? this.asLink(index, item.linkTo, children) : children
                    })}
                </Menu>
            </div>
        );
    }
}

MenuButton.propTypes = {
    id: PropTypes.number.isRequired,
    options: PropTypes.array.isRequired,
    children: PropTypes.any.isRequired,
    classes: PropTypes.object.isRequired,
    subject: PropTypes.object
}

export default withStyles(styles)(MenuButton)
